export interface DetailSearchState {
  isOpen: boolean
}

const initialState: DetailSearchState = {
  isOpen: false,
}

// actions
const OPEN = 'gnb/detailSearch/OPEN'
const CLOSE = 'gnb/detailSearch/CLOSE'
const TOGGLE = 'gnb/detailSearch/TOGGLE'

// action creators
export const toggleDetailSearch = () => {
  return {
    type: TOGGLE,
  }
}

export const openDetailSearch = () => {
  return {
    type: OPEN,
  }
}

export const closeDetailSearch = () => {
  return {
    type: CLOSE,
  }
}

// reducers
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case OPEN:
      return {
        ...state,
        isOpen: true,
      }
    case CLOSE:
      return {
        ...state,
        isOpen: false,
      }
    case TOGGLE:
      return {
        ...state,
        isOpen: !state.isOpen,
      }
    default:
      return state
  }
}

export default reducers
